var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.962891,
    y: 0.605469,
    width: 35,
    height: 35,
    rx: 8,
    fill: "black",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6549_198049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8691 19.6484C12.9769 19.6484 13.0802 19.6912 13.1564 19.7674C13.2326 19.8436 13.2754 19.9469 13.2754 20.0547V22.0859C13.2754 22.3014 13.361 22.5081 13.5134 22.6605C13.6657 22.8128 13.8724 22.8984 14.0879 22.8984H23.8379C24.0534 22.8984 24.26 22.8128 24.4124 22.6605C24.5648 22.5081 24.6504 22.3014 24.6504 22.0859V20.0547C24.6504 19.9469 24.6932 19.8436 24.7694 19.7674C24.8456 19.6912 24.9489 19.6484 25.0566 19.6484C25.1644 19.6484 25.2677 19.6912 25.3439 19.7674C25.4201 19.8436 25.4629 19.9469 25.4629 20.0547V22.0859C25.4629 22.5169 25.2917 22.9302 24.9869 23.235C24.6822 23.5397 24.2689 23.7109 23.8379 23.7109H14.0879C13.6569 23.7109 13.2436 23.5397 12.9388 23.235C12.6341 22.9302 12.4629 22.5169 12.4629 22.0859V20.0547C12.4629 19.9469 12.5057 19.8436 12.5819 19.7674C12.6581 19.6912 12.7614 19.6484 12.8691 19.6484Z",
    fill: "#46494E",
    stroke: "#46494E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6753 21.2368C18.713 21.2747 18.7579 21.3047 18.8072 21.3252C18.8566 21.3457 18.9095 21.3562 18.9629 21.3562C19.0164 21.3562 19.0693 21.3457 19.1186 21.3252C19.168 21.3047 19.2128 21.2747 19.2505 21.2368L21.688 18.7993C21.7643 18.7231 21.8072 18.6196 21.8072 18.5117C21.8072 18.4038 21.7643 18.3004 21.688 18.2241C21.6118 18.1478 21.5083 18.105 21.4004 18.105C21.2925 18.105 21.1891 18.1478 21.1128 18.2241L19.3692 19.9685V12.8242C19.3692 12.7165 19.3264 12.6131 19.2502 12.537C19.174 12.4608 19.0707 12.418 18.9629 12.418C18.8552 12.418 18.7518 12.4608 18.6757 12.537C18.5995 12.6131 18.5567 12.7165 18.5567 12.8242V19.9685L16.813 18.2241C16.7368 18.1478 16.6333 18.105 16.5254 18.105C16.4175 18.105 16.3141 18.1478 16.2378 18.2241C16.1615 18.3004 16.1187 18.4038 16.1187 18.5117C16.1187 18.6196 16.1615 18.7231 16.2378 18.7993L18.6753 21.2368Z",
    fill: "#46494E",
    stroke: "#46494E",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6549_198049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(12.4629 11.6055)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/downloadButton.887011e8.svg";
export { ForwardRef as ReactComponent };